<!--
    描述：指标分析右侧表格
    时间：2020-06-03
    Created by ws
-->
<template>
	<div class="target-sheet-main"
		 v-loading="loading">
		<div class="target-sheet-left"
			 ref="leftInfo">
			<ul class="info-box"
				@click="hignLightRow">

				<!-- 列内容 -->
				<li v-for="(m, n) in textInfo"
					:key="'标题' + n"
					:class="[{'text-header': m.level === 'topic'}, {'column-header': n === 0}]">
					<!-- 根据不同的布局模式渲染不同的排版 -->
					<!-- colspan = 4 -->
					<template v-if="m.colspan === '4'">
						<div class="w100 text-overflow"
							 :class="`align-${m.aligns[0]}`">{{ m.values[0] }}</div>
					</template>

					<!-- colspan = 22 -->
					<template v-if="m.colspan === '22'">
						<div class="flex-item pdr5 text-overflow"
							 v-for="(value1, index1) in m.values"
							 :key="'标题' + '-' + n + '-' + index1"
							 :class="[{'bd-right': index1 !== m.values.length - 1}, `align-${m.aligns[index1]}`]">
							{{ value1 }}</div>
					</template>

					<!-- colspan = 211 -->
					<template v-if="m.colspan === '211'">
						<div class="flex-item bd-right pdr5 text-overflow"
							 :class="`align-${m.aligns[0]}`">{{ m.values[0] }}</div>
						<div class="flex-item flex">
							<div class="flex-item bd-right pdl5 pdr5 text-overflow"
								 :class="`align-${m.aligns[1]}`">{{ m.values[1] }}</div>
							<div class="flex-item pdl5 text-overflow"
								 :class="`align-${m.aligns[2]}`">{{ m.values[2] }}</div>
						</div>
					</template>

					<!-- colspan = 112 -->
					<template v-if="m.colspan === '112'">
						<div class="flex-item flex bd-right">
							<div class="flex-item bd-right pdr5 text-overflow"
								 :class="`align-${m.aligns[0]}`">{{ m.values[0] }}</div>
							<div class="flex-item pdl5 text-overflow"
								 :class="`align-${m.aligns[1]}`">{{ m.values[1] }}</div>
						</div>
						<div class="flex-item pdl5 text-overflow"
							 :class="`align-${m.aligns[2]}`">{{ m.values[2] }}</div>
					</template>

					<!-- colspan = 1111 -->
					<template v-if="m.colspan === '1111'">
						<div class="flex-item bd-right flex">
							<div class="flex-item bd-right pdr5 text-overflow"
								 :class="`align-${m.aligns[0]}`">{{ m.values[0] }}</div>
							<div class="flex-item pdl5 text-overflow"
								 :class="`align-${m.aligns[1]}`">{{ m.values[1] }}</div>
						</div>
						<div class="flex-item flex">
							<div class="flex-item bd-right pdl5 pdr5 text-overflow"
								 :class="`align-${m.aligns[2]}`">{{ m.values[2] }}</div>
							<div class="flex-item pdl5 text-overflow"
								 :class="`align-${m.aligns[3]}`">{{ m.values[3] }}</div>
						</div>
					</template>
				</li>

			</ul>
		</div>
		<div class="target-sheet-right"
			 ref="rightList"
			 v-if="filterData.length > 0">
			<!-- 六算对象 -->
			<ul class="info-box"
				v-for="(item, index) in filterData"
				:class="{'active-box': activeTab === index}"
				:key="'基础信息' + index"
				@click="handleClick(index)">

				<!-- 列内容 -->
				<li v-for="(m, n) in item.list"
					:key="'row' + index + n"
					:class="[{'text-header': m.level === 'topic'}, {'column-header': n === 0}]">
					<!-- 根据不同的布局模式渲染不同的排版 -->
					<!-- colspan = 4 -->
					<template v-if="m.colspan === '4'">
						<div class="w100 text-overflow"
							 :class="`align-${m.aligns[0]}`"
							 :title="m.values[0]">{{ m.values[0] }}</div>
					</template>

					<!-- colspan = 22 -->
					<template v-if="m.colspan === '22'">
						<div class="flex-item text-overflow"
							 v-for="(value1, index1) in m.values"
							 :key="index + '-' + n + '-' + index1"
							 :class="[{'bd-right': index1 !== m.values.length - 1}, `align-${m.aligns[index1]}`, {'pdr5': index1 === 0}]">
							{{ value1 }}</div>
					</template>

					<!-- colspan = 211 -->
					<template v-if="m.colspan === '211'">
						<div class="flex-item bd-right pdr5 text-overflow"
							 :class="`align-${m.aligns[0]}`"
							 :title="m.values[0]">{{ m.values[0] }}</div>
						<div class="flex-item flex">
							<div class="flex-item bd-right pdl5 pdr5 text-overflow"
								 :class="`align-${m.aligns[1]}`">{{ m.values[1] }}</div>
							<div class="flex-item pdl5 text-overflow"
								 :class="`align-${m.aligns[2]}`">{{ m.values[2] }}</div>
						</div>
					</template>

					<!-- colspan = 112 -->
					<template v-if="m.colspan === '112'">
						<div class="flex-item flex bd-right">
							<div class="flex-item bd-right pdr5 text-overflow"
								 :class="`align-${m.aligns[0]}`">{{ m.values[0] }}</div>
							<div class="flex-item pdl5 text-overflow"
								 :class="`align-${m.aligns[1]}`">{{ m.values[1] }}</div>
						</div>
						<div class="flex-item pdl5 text-overflow"
							 :class="`align-${m.aligns[2]}`">{{ m.values[2] }}</div>
					</template>

					<!-- colspan = 121 -->
					<template v-if="m.colspan === '121'">
						<div class="w25 bd-right pdr5 text-overflow"
							 :class="`align-${m.aligns[0]}`">{{ m.values[0] }}</div>
						<div class="flex-item pdr5 pdl5 bd-right text-overflow"
							 :class="`align-${m.aligns[1]}`">{{ m.values[1] }}</div>
						<div class="w25 pdl5 text-overflow"
							 :class="`align-${m.aligns[2]}`">{{ m.values[2] }}</div>
					</template>

					<!-- colspan = 1111 -->
					<template v-if="m.colspan === '1111'">
						<div class="flex-item bd-right flex">
							<div class="flex-item bd-right pdr5 text-overflow"
								 :class="`align-${m.aligns[0]}`">{{ m.values[0] }}</div>
							<div class="flex-item pdl5 text-overflow"
								 :class="`align-${m.aligns[1]}`">{{ m.values[1] }}</div>
						</div>
						<div class="flex-item flex">
							<div class="flex-item bd-right pdl5 pdr5 text-overflow"
								 :class="`align-${m.aligns[2]}`">{{ m.values[2] }}</div>
							<div class="flex-item pdl5 text-overflow"
								 :class="`align-${m.aligns[3]}`">{{ m.values[3] }}</div>
						</div>
					</template>
				</li>
			</ul>
		</div>
		<div class="target-sheet-right"
			 id="rightList"
			 v-else>
			<div class="no-content">暂无数据</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'target_sheet_home',
	props: {
		// 返回来的数据对象
		resData: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			textInfo: [],
			infoList: [],
			loading: false,
			activeTab: ''
		}
	},
	created() {
		this.getTableData()
	},
	mounted() {
		setTimeout(() => {
			this.handleScroll()
		}, 1000)
	},
	methods: {
		// 获取数据
		getTableData() {
			this.loading = true

			// 内容列赋值
			this.infoList = this.resData.contentColumn || []

			// 标题列赋值
			this.textInfo = this.resData.titleColumn || []

			setTimeout(() => {
				this.loading = false
			}, 1000)
		},

		// 切换收起隐藏
		changeShow(value) {
			this.infoList.map((item, index) => {
				let _row = item.dataList.find(x => x.value === value)

				if (_row) {
					_row.show = !_row.show

					this.infoList.map(x => {
						x.dataList.map(y => y.show)
					})
					console.log(this.infoList)
				}
			})
		},

		// 计算总用地面积
		getTotalArea(array) {
			if (array.length === 0) {
				return 0
			}

			let count = 0
			array.forEach(x => {
				let num = parseFloat(x.totalArea.value) || 0
				count += num
			})
			return count
		},

		// 计算总车位信息
		getTotalCarNum(obj) {
			let val1 = parseFloat(obj.groundOrdinary) || 0
			let val2 = parseFloat(obj.groundMechine) || 0
			let val3 = parseFloat(obj.underGroundOrdinary) || 0
			let val4 = parseFloat(obj.underGroundMechine) || 0

			return parseFloat(
				val1
					.add(val2)
					.add(val3)
					.add(val4)
			)
		},

		// 盒子点击事件
		handleClick(index) {
			this.activeTab = index
		},

		// 左侧点击高亮行
		hignLightRow(event) {
			let e = event || window.event
			let ul = e.target.closest('ul')
			let lis = Array.from(ul.querySelectorAll('li'))
			let _index = lis.indexOf(e.target)

			let box_list = Array.from(document.querySelectorAll('.info-box'))
			box_list.forEach(x => {
				let _children = Array.from(x.querySelectorAll('li'))
				// 重置其它 li
				_children.forEach(y => {
					y.style.backgroundColor = 'transparent'
				})
				if (_children[_index])
					_children[_index].style.backgroundColor = '#ff0'
			})
		},

		// 滚动联动事件
		handleScroll() {
			if (this.filterData.length > 0) {
				this.$nextTick(() => {
					let _left = this.$refs.leftInfo
					let _right = this.$refs.rightList

					if (
						_right.scrollHeight &&
						_right.scrollHeight >= _right.offsetHeight
					) {
						_right.addEventListener('scroll', () => {
							let scrollTop = _right.scrollTop
							_left.scrollTo(0, scrollTop)
						})
					}
				})
			}
		}
	},
	computed: {
		filterData() {
			let arr = this.infoList.filter(x => x.show === 1)

			return arr
		}
	},
	watch: {
		resData(val) {
			// console.log('路由变化了')
			this.getTableData()

			setTimeout(() => {
				this.handleScroll()
			}, 1000)
		}
	}
}
</script>

<style lang="less" scoped>
.target-sheet-main {
	@bdColor: #ccc;
	width: 100%;
	height: 100%;
	display: flex;
	border: 1px solid @bdColor;

	.target-sheet-left {
		width: 220px;
		height: 100%;
		padding-bottom: 7px;
		background-color: #faebd7;
		border-right: 1px solid @bdColor;
		overflow: hidden;
	}

	.target-sheet-right {
		flex: 1;
		height: 100%;
		display: flex;
		// background-color: #98d2f1;
		overflow: auto;

		.info-box {
			flex: 1;
			min-width: 420px;
			border-right: 1px solid @bdColor;
		}

		.no-content {
			font-size: 30px;
			text-align: center;
			width: 100%;
			margin: auto auto;
		}
	}

	.info-box {
		min-width: 100%;
		height: fit-content;
		li {
			height: 32px;
			line-height: 32px;
			padding: 0 7px;
			display: flex;
			justify-content: flex-end;

			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
			border-bottom: 1px solid @bdColor;
		}

		li.text-header {
			justify-content: flex-start;
			background-color: #98d2f1 !important;
			color: #333;
		}

		li.text-name {
			justify-content: center;
			font-weight: 700;
			font-size: 15px;
		}

		li:last-child {
			border-bottom: none;
		}

		.flex-item {
			width: 50%;
			// text-align: center;
		}

		.align-right {
			text-align: right;
		}

		.align-center {
			text-align: center;
		}

		.num-right {
			text-align: right;
			padding-right: 10px;
		}

		.color-1 {
			color: #00469d;
		}

		.bd-right {
			border-right: 1px solid @bdColor;
		}

		li.column-header {
			background-color: #0073ab !important;
			color: #fff;
		}
	}

	.w25 {
		width: 25%;
	}

	.active-box {
		@bgColor: #aeffe4;

		background-color: @bgColor;
	}
}
</style>